var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.12 11.3501L12.89 15.5801V6.12012C12.89 5.8549 12.7846 5.60055 12.5971 5.41301C12.4096 5.22547 12.1552 5.12012 11.89 5.12012C11.6248 5.12012 11.3704 5.22547 11.1829 5.41301C10.9954 5.60055 10.89 5.8549 10.89 6.12012V15.5801L6.66 11.3501C6.56676 11.2569 6.45607 11.1829 6.33425 11.1325C6.21243 11.082 6.08186 11.056 5.95 11.056C5.81814 11.056 5.68757 11.082 5.56575 11.1325C5.44393 11.1829 5.33324 11.2569 5.24 11.3501C5.14676 11.4434 5.0728 11.554 5.02234 11.6759C4.97188 11.7977 4.94591 11.9283 4.94591 12.0601C4.94591 12.192 4.97188 12.3225 5.02234 12.4444C5.0728 12.5662 5.14676 12.6769 5.24 12.7701L11.18 18.7001C11.2713 18.7937 11.38 18.8684 11.5 18.9201C11.6245 18.9675 11.7568 18.9913 11.89 18.9901C12.02 18.9917 12.1491 18.9679 12.27 18.9201C12.39 18.8684 12.4987 18.7937 12.59 18.7001L18.53 12.7701C18.6237 12.6772 18.6981 12.5666 18.7489 12.4447C18.7997 12.3228 18.8258 12.1921 18.8258 12.0601C18.8258 11.9281 18.7997 11.7974 18.7489 11.6755C18.6981 11.5537 18.6237 11.4431 18.53 11.3501C18.3426 11.1639 18.0892 11.0593 17.825 11.0593C17.5608 11.0593 17.3074 11.1639 17.12 11.3501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/IconArrowDown.195b1861e186117059a0eebac5ede75c.svg";
export { ForwardRef as ReactComponent };